/**
 * AppAssets.ts
 * 
 * This file centralizes all asset paths used throughout the application.
 * By storing all image paths and other assets here, we make it easier to:
 * 1. Update assets in one place
 * 2. Maintain consistency across the application
 * 3. Quickly find and replace assets when needed
 */

import mapFallbackImg from '../../assets/images/map-fallback.webp';
// Use string paths instead of imports for logo images that might not exist yet
const logoImg = '/assets/images/logo.webp';

/**
 * Homepage hero background.
 *
 * This used to point at video/a2ssarl-video-gif.gif — a 26 MB animated GIF
 * loaded through an <img>, which was the Largest Contentful Paint element on
 * the homepage. It is now a 20 KB still frame extracted by
 * scripts/optimize-images.js. If the motion is ever wanted back, ship a real
 * <video autoplay muted loop playsinline> with an MP4 and keep this as its
 * poster — never a multi-megabyte GIF.
 */
const heroBackground = '/images/background/hero-poster.webp';

const AppAssets = {
  heroBackground,

  // Logo assets
  logo: {
    main: logoImg,
    favicon: '/favicon.ico',
  },
  

  
  // Maps
  maps: {
    fallback: mapFallbackImg,
  },
  



};

export default AppAssets;
